import { render, staticRenderFns } from "./LeadsColector.vue?vue&type=template&id=43a35b39&scoped=true&"
import script from "./LeadsColector.vue?vue&type=script&lang=js&"
export * from "./LeadsColector.vue?vue&type=script&lang=js&"
import style0 from "./LeadsColector.vue?vue&type=style&index=0&id=43a35b39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a35b39",
  null
  
)

export default component.exports